import { motion } from "framer-motion";

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const tabs = [
  { id: "overview", label: "Overview" },
  { id: "financials", label: "Financials" },
  { id: "valuation", label: "Valuation & Ratios" },
  { id: "technicals", label: "Technicals" },
  { id: "ownership", label: "Ownership" },
  { id: "events", label: "Events" },
  { id: "news", label: "News & Docs" },
];

const TabNavigation = ({ activeTab, onTabChange }: TabNavigationProps) => {
  return (
    <div className="scrollbar-hide sticky top-0 z-30 overflow-x-auto border-b border-gray-100 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex h-14 items-center gap-8">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`relative flex h-full items-center whitespace-nowrap font-sans text-sm font-medium transition-all ${
                activeTab === tab.id
                  ? "text-[#00D09C]"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab.label}
              {activeTab === tab.id && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute bottom-0 left-0 right-0 h-1 rounded-t-full bg-[#00D09C]"
                />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabNavigation;
